export type EditorTransferTarget = {
  segment: 'lines' | 'quotes' | 'files';
  kind: 'demand' | 'quotation' | 'auto';
  acceptsText: boolean;
  hint: string;
  label: string;
};

const TARGETS: Record<EditorTransferTarget['segment'], EditorTransferTarget> = {
  lines: {
    segment: 'lines',
    kind: 'demand',
    acceptsText: true,
    hint: 'Drop a demand file or item list to add line items',
    label: 'Line Items — paste a list or files',
  },
  quotes: {
    segment: 'quotes',
    kind: 'quotation',
    acceptsText: false,
    hint: 'Drop a vendor quote or comparison sheet',
    label: 'Quotes — paste quotation files',
  },
  files: {
    segment: 'files',
    kind: 'auto',
    acceptsText: false,
    hint: 'Drop documents — their type will be detected automatically',
    label: 'Documents — paste files',
  },
};

/** Describes the editor sections that accept clipboard/drop content. */
export function editorTransferTarget(
  segment: string | null | undefined,
  readOnly = false,
): EditorTransferTarget | null {
  if (readOnly || segment === undefined || segment === null || !(segment in TARGETS)) return null;
  return TARGETS[segment as EditorTransferTarget['segment']];
}
